export const baseUrl = import.meta.env.VITE_API_URL || 'Fallback-URL'
export const baseUrlIdent = import.meta.env.VITE_IDENT_URL || 'Fallback-URL'

export const protectedResources = {
  apiList: {
    //#region Event
    readEvents: baseUrl + '/Event/ReadEvents',
    //#endregion

    //#region Settings
    readCountryStates: baseUrl + '/Setting/ReadCountryStates',
    readSalutation: baseUrl + '/Setting/ReadSalutations',
    readTitles: baseUrl + '/Setting/readTitles',
    readActivities: baseUrl + '/Setting/ReadActivities',
    //#endregion

    //#region Web
    readWebCode: baseUrl + '/Web/code',
    readWebEvent: baseUrl + '/Web/event',
    readWebRegistration: baseUrl + '/Web/registration',
    readWebHotel: baseUrl + '/web/hotels',
    //#endregion

    //#region Ident
    readCheckUsername: baseUrlIdent + '/Account/CheckUsername',
    readSilentRegister: baseUrlIdent + '/Account/SilentRegister',
    //#endregion

    postInhouseReq: baseUrl + '/Web/inhouseReq',

    readToken: baseUrl + '/Token/Read',
  },
}
